<template >
  <div :key="'composition-api-basic-example-template'">
    <pre><code class="html" data-trim data-noescape data-line-numbers="1-99" v-html="exampleText"></code></pre>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exampleText: `&lt;template&gt;
  &lt;button @click=&quot;increment&quot;&gt;
    Count is: {{ state.count }}, double is: {{ state.double }}
  &lt;/button&gt;
&lt;/template&gt;`
    };
  }
};
</script>
